var path = '/templates/zenclerk_s/sites/campaigns/edit/instruction_makeshop.html';
var html = "<ng-container translate=sites.campaigns.edit.instruction.makeshop translate-value-service={{$ctrl.ZcsOemService.getName()}} translate-value-link=\"<a href='http://ms-manual.makeshop.jp/coupon/' target='_blank'>{{ 'sites.campaigns.edit.instruction.here' | translate }}</a>\"></ng-container>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_s_modules/zenclerk_s/sites/campaigns/edit/instruction_makeshop.html
// module id = 1393
// module chunks = 0